import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67317303"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "line-with-text" }
const _hoisted_2 = ["innerHTML"]

import {ref, reactive} from 'vue'
  import Image from '@/components/Image.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselComponent',
  props: ['value'],
  setup(__props) {

  const img = __props;
  

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img.value, (image) => {
    return (_openBlock(), _createElementBlock("div", null, [
      _createElementVNode("h3", _hoisted_1, [
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        }),
        _createTextVNode(" " + _toDisplayString(image.title) + " ", 1),
        _createVNode(_component_el_divider, {
          class: "divider",
          "border-style": "double"
        })
      ]),
      _createVNode(_component_el_carousel, {
        interval: 4000,
        arrow: "always",
        style: {"height":"52rem"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(image.data, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_carousel_item, {
              key: index,
              style: {"height":"65rem"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: item.desc
                    }, null, 8, _hoisted_2),
                    _createVNode(Image, {
                      value: item.src
                    }, null, 8, ["value"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 2
      }, 1024)
    ]))
  }), 256))
}
}

})